// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '대웅바이오',
  targetSheetName: '네트워크',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가(원)',
    commissionRate: '수수료(%)',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    '약호',
    'NO',
    '제품군',
    '담당PM',
    '구분',
    '제품명',
    '성분·함량',
    '보험코드',
    '약가(원)',
    '오리지널 약가',
    '성분동일가/ 상한가',
    '약가(원) 약가인하반영',
    '포장단위',
    '분류',
    '대조약',
    '수수료(%)',
    '비 고',
  ],
});
